import { useMemo } from 'react';
const useComboboxWrapperStyles = ({ styles, isToggled, hasSuggestions, dropdownDirection }) => useMemo(() => {
    return {
        ...(isToggled && hasSuggestions
            ? {
                borderRadius: dropdownDirection === 'up' ? '0 0 2.6rem 2.6rem' : '2.6rem 2.6rem 0 0'
            }
            : {}),
        ...styles
    };
}, [styles, isToggled, hasSuggestions, dropdownDirection]);
export default useComboboxWrapperStyles;
//# sourceMappingURL=useComboboxWrapperStyles.js.map